import cookie from 'js-cookie';
import {
  getAnonymousJWTTokenKey,
  getMemberJWTTokenKey,
} from './getMemberJWTTokenKey.web';
import axios from 'axios';
import { isWeb } from './isWeb';
import { localStorageBridge } from './bridge';

export const getMemberToken = async () => {
  if (!isWeb) {
    return localStorageBridge.getString('ably-jwt-token');
  }

  const memberJWTTokenKey = await getMemberJWTTokenKey();
  return cookie.get(memberJWTTokenKey);
};

export const getAnonymousToken = async (baseUrl?: string) => {
  if (!isWeb) {
    const anonymousToken = await localStorageBridge.getString(
      'ably-anonymous-token',
    );
    return anonymousToken;
  }

  const anonymousJWTTokenKey = await getAnonymousJWTTokenKey();

  const cookieValue = cookie.get(anonymousJWTTokenKey);
  if (cookieValue) {
    return cookieValue;
  }

  if (baseUrl) {
    const anonymousToken = await axios
      .get<{ token: string }>(`${baseUrl}/api/v2/anonymous/token/`)
      .then(result => result.data);
    cookie.set(anonymousJWTTokenKey, anonymousToken.token);
    return anonymousToken.token;
  }

  return undefined;
};
